import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import ProductCard from '../components/ProductCard';
import SectionReveal from '../components/SectionReveal';
import './Home.css';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTestimonial: 0,
      currentOwnerImage: 0,
    };
  }

  componentDidMount() {
    this.testimonialTimer = setInterval(() => {
      this.setState((prev) => ({
        currentTestimonial: (prev.currentTestimonial + 1) % config.testimonials.length,
      }));
    }, 5000);

    this.ownerImageTimer = setInterval(() => {
      this.setState((prev) => ({
        currentOwnerImage: (prev.currentOwnerImage + 1) % config.ownerImages.length,
      }));
    }, 4000);
  }

  componentWillUnmount() {
    clearInterval(this.testimonialTimer);
    clearInterval(this.ownerImageTimer);
  }

  render() {
    const { currentTestimonial, currentOwnerImage } = this.state;

    return (
      <main className="home">
        {/* ============ HERO SECTION ============ */}
        <section className="hero">
          <div className="hero__bg">
            <div className="hero__bg-overlay"></div>
            <img src="/images/owner-prep.jpg" alt="Fresh fruit preparation" className="hero__bg-img" />
          </div>

          {/* Falling Fruits Animation */}
          <div className="hero__fruits" aria-hidden="true">
            <span className="hero__fruit hero__fruit--1">🍎</span>
            <span className="hero__fruit hero__fruit--2">🍌</span>
            <span className="hero__fruit hero__fruit--3">🍊</span>
            <span className="hero__fruit hero__fruit--4">🍓</span>
            <span className="hero__fruit hero__fruit--5">🍉</span>
            <span className="hero__fruit hero__fruit--6">🥝</span>
            <span className="hero__fruit hero__fruit--7">🍍</span>
            <span className="hero__fruit hero__fruit--8">🍇</span>
            <span className="hero__fruit hero__fruit--9">🫐</span>
            <span className="hero__fruit hero__fruit--10">🍈</span>
            <span className="hero__fruit hero__fruit--11">🥭</span>
            <span className="hero__fruit hero__fruit--12">🍑</span>
          </div>

          <div className="container hero__container" style={{ paddingTop: '90px' }}>
            <div className="hero__content">
              <h1 className="hero__title" style={{ opacity: 1, visibility: 'visible' }}>
                Fuel Your <span className="hero__title-accent">Ambition</span> with Nature's Best.
              </h1>
              <p className="hero__subtitle" style={{ opacity: 1, visibility: 'visible' }}>
                {config.brand.description}
              </p>
              <div className="hero__actions">
                <a
                  href={config.getWhatsAppUrl('Hello FAL SUTRA! I want to order fresh fruit cups 🍎')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-whatsapp hero__cta"
                >
                  👉 Order on WhatsApp
                </a>
                <Link to="/menu" className="btn btn-secondary hero__cta-secondary">
                  View Menu
                </Link>
              </div>
              <div className="hero__stats">
                <div className="hero__stat">
                  <span className="hero__stat-number">500+</span>
                  <span className="hero__stat-label">Happy Customers</span>
                </div>
                <div className="hero__stat-divider"></div>
                <div className="hero__stat">
                  <span className="hero__stat-number">4 AM</span>
                  <span className="hero__stat-label">Fresh Sourced</span>
                </div>
                <div className="hero__stat-divider"></div>
                <div className="hero__stat">
                  <span className="hero__stat-number">0%</span>
                  <span className="hero__stat-label">Preservatives</span>
                </div>
              </div>
            </div>
            <div className="hero__visual animate-fadeInUp delay-300">
              <div className="hero__image-card">
                <img src="/images/product-cup.jpg" alt="FAL SUTRA Fruit Cup" className="hero__image" />
              </div>
              <div className="hero__price-tag">
                <span>Starting at</span>
                <strong>₹{config.products[0].monthlyPrice.toLocaleString('en-IN')}/mo</strong>
              </div>
            </div>
          </div>
          <div className="hero__scroll-indicator">
            <div className="hero__scroll-line"></div>
          </div>
        </section>

        {/* ============ ABOUT / WHY FAL SUTRA ============ */}
        <section className="section why-section">
          <div className="container">
            <SectionReveal>
              <div className="section-header">
                <span className="section-badge">Our Promise</span>
                <h2>Why FAL SUTRA?</h2>
                <p>We don't just sell fruit — we deliver a healthier lifestyle to your doorstep.</p>
              </div>
            </SectionReveal>

            <div className="why-grid">
              <SectionReveal delay={0.1}>
                <div className="why-card">
                  <div className="why-card__icon">🌾</div>
                  <h3>Farm to Desk</h3>
                  <p>Sourced daily at 4 AM from local farms. No cold storage, no stale produce — just peak freshness.</p>
                </div>
              </SectionReveal>
              <SectionReveal delay={0.2}>
                <div className="why-card">
                  <div className="why-card__icon">🚫</div>
                  <h3>Zero Preservatives</h3>
                  <p>Freshly cut upon every order. No sugar, no additives — 100% natural energy for your body.</p>
                </div>
              </SectionReveal>
              <SectionReveal delay={0.3}>
                <div className="why-card">
                  <div className="why-card__icon">🧤</div>
                  <h3>Hygiene First</h3>
                  <p>Processed in a fully sanitized environment. FSSAI Registered for your peace of mind.</p>
                </div>
              </SectionReveal>
            </div>
          </div>
        </section>

        {/* ============ PRODUCTS ============ */}
        <section className="section products-section" id="products">
          <div className="container">
            <SectionReveal>
              <div className="section-header">
                <span className="section-badge">Freshly Crafted Daily</span>
                <h2>Our Fuel Cups</h2>
                <p>No added sugar, zero preservatives. Just 100% natural energy.</p>
              </div>
            </SectionReveal>

            <div className="products-grid">
              {config.products.map((product, idx) => (
                <SectionReveal key={product.id} delay={idx * 0.15}>
                  <ProductCard product={product} featured={idx === 1} />
                </SectionReveal>
              ))}
            </div>

            {/* Trial Note */}
            <SectionReveal delay={0.5}>
              <div className="home-trial-note">
                <p className="home-trial-note__text">
                  Not sure yet? <strong>Book a 1 day paid trial drop - ₹99 !!!</strong>
                </p>
                <a
                  href={config.getWhatsAppTrialUrl('')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary home-trial-note__btn"
                >
                  Book Trial Drop
                </a>
              </div>
            </SectionReveal>
          </div>
        </section>

        {/* ============ OWNER SECTION ============ */}
        <section className="section owner-section">
          <div className="container">
            <div className="owner-grid">
              <SectionReveal animation="slideInLeft">
                <div className="owner-image-wrap">
                  <div className="owner-carousel">
                    <div
                      className="owner-carousel__track"
                      style={{ transform: `translateX(-${currentOwnerImage * 100}%)` }}
                    >
                      {config.ownerImages.map((src, idx) => (
                        <div key={idx} className="owner-carousel__slide">
                          <img
                            src={src}
                            alt={`FAL SUTRA ${idx + 1}`}
                            className="owner-image"
                          />
                        </div>
                      ))}
                    </div>

                    {/* Prev / Next Arrows */}
                    <button
                      className="owner-carousel__arrow owner-carousel__arrow--prev"
                      onClick={() =>
                        this.setState({
                          currentOwnerImage:
                            (currentOwnerImage - 1 + config.ownerImages.length) %
                            config.ownerImages.length,
                        })
                      }
                      aria-label="Previous image"
                    >
                      ‹
                    </button>
                    <button
                      className="owner-carousel__arrow owner-carousel__arrow--next"
                      onClick={() =>
                        this.setState({
                          currentOwnerImage:
                            (currentOwnerImage + 1) % config.ownerImages.length,
                        })
                      }
                      aria-label="Next image"
                    >
                      ›
                    </button>
                  </div>

                  {/* Dots */}
                  <div className="owner-carousel-dots">
                    {config.ownerImages.map((_, idx) => (
                      <button
                        key={idx}
                        className={`owner-carousel-dot ${idx === currentOwnerImage ? 'owner-carousel-dot--active' : ''}`}
                        onClick={() => this.setState({ currentOwnerImage: idx })}
                        aria-label={`Image ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </SectionReveal>
              <SectionReveal animation="slideInRight" delay={0.2}>
                <div className="owner-content">
                  <span className="section-badge">The Story</span>
                  <h2>Crafted with Passion</h2>
                  <p>
                    Every FAL SUTRA cup is handcrafted with care. Our team selects the freshest seasonal fruits every morning at 5 AM, ensuring you receive nothing but the best nature has to offer.
                  </p>
                  <p>
                    From preparation to packaging — hygiene, quality, and love go into every cup. That's the FAL SUTRA promise.
                  </p>
                  <Link to="/about" className="btn btn-primary">
                    Learn More About Us
                  </Link>
                </div>
              </SectionReveal>
            </div>
          </div>
        </section>

        {/* ============ SERVICES PREVIEW ============ */}
        <section className="section services-preview-section">
          <div className="container">
            <SectionReveal>
              <div className="section-header">
                <span className="section-badge">What We Offer</span>
                <h2>Our Services</h2>
                <p>Elevating health for individuals, athletes, and corporate teams.</p>
              </div>
            </SectionReveal>

            <div className="services-preview-grid">
              {config.services.map((service, idx) => (
                <SectionReveal key={service.id} delay={idx * 0.1}>
                  <div className="service-preview-card">
                    <span className="service-preview-card__icon">{service.icon}</span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                  </div>
                </SectionReveal>
              ))}
            </div>

            <SectionReveal delay={0.4}>
              <div className="services-preview-cta">
                <Link to="/services" className="btn btn-primary">
                  Explore All Services →
                </Link>
              </div>
            </SectionReveal>
          </div>
        </section>

        {/* ============ TESTIMONIALS ============ */}
        <section className="section testimonials-section">
          <div className="container">
            <SectionReveal>
              <div className="section-header">
                <span className="section-badge">Happy Customers</span>
                <h2>What They Say</h2>
              </div>
            </SectionReveal>

            <div className="testimonials-carousel">
              {config.testimonials.map((testimonial, idx) => (
                <div
                  key={idx}
                  className={`testimonial-card ${idx === currentTestimonial ? 'testimonial-card--active' : ''}`}
                >
                  <div className="testimonial-card__stars">
                    {'★'.repeat(testimonial.rating)}
                  </div>
                  <p className="testimonial-card__review">"{testimonial.review}"</p>
                  <div className="testimonial-card__author">
                    {/* <img src={testimonial.image} alt={testimonial.name} className="testimonial-card__avatar" /> */}
                    <div>
                      <strong>{testimonial.name}</strong>
                      <span>{testimonial.role}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="testimonials-dots">
              {config.testimonials.map((_, idx) => (
                <button
                  key={idx}
                  className={`testimonials-dot ${idx === currentTestimonial ? 'testimonials-dot--active' : ''}`}
                  onClick={() => this.setState({ currentTestimonial: idx })}
                  aria-label={`Go to testimonial ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* ============ CTA SECTION ============ */}
        <section className="cta-section">
          <div className="container">
            <SectionReveal>
              <div className="cta-content">
                <h2>Ready to Fuel Your Day?</h2>
                <p>Order your fresh fruit cup now and taste the difference.</p>
                <div className="cta-actions">
                  <a
                    href={config.getWhatsAppUrl('Hello FAL SUTRA! I want to order 🍎')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-whatsapp"
                  >
                    📱 Order on WhatsApp
                  </a>
                  <Link to="/corporate-trial" className="btn" style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: '2px solid rgba(255,255,255,0.3)' }}>
                    Request Corporate Trial
                  </Link>
                </div>
                <p style={{ marginTop: '16px', fontSize: '0.85rem', opacity: 0.7 }}>
                  By ordering, you agree to our <Link to="/terms" style={{ color: '#fff', textDecoration: 'underline' }}>Terms & Conditions</Link>.
                </p>
              </div>
            </SectionReveal>
          </div>
        </section>
      </main>
    );
  }
}

export default Home;
